import apiClient from './client.js';

export async function fetchLeadActivity (leadId) {
  const { data } = await apiClient.get(`/leads/${leadId}/activity`);
  return data?.items || [];
}
